module.exports = __webpack_public_path__ + "img/google-play.8edfc6f9.svg";